webpackJsonp([132385871910677],{

/***/ 1814:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/news/in-an-age-where-data-is-king-it-s-still-only-ideas-that-move-people/"},"frontmatter":{"title":"In an age where 'data is king', it's still only ideas that move people.","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1160x450 burger jack article header image v1-fefe2efcf5fbd1acfdee6c510561884b.jpg"}}},"original":"/img/1160x450 burger jack article header image v1.jpg"},"category":"Insight"}}}]}},"pathContext":{"tag":"Creative"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-creative-2bdfc4946785c09910a9.js